import { render, staticRenderFns } from "./InvAllList.vue?vue&type=template&id=5e07564e&scoped=true&"
import script from "./InvAllList.vue?vue&type=script&lang=js&"
export * from "./InvAllList.vue?vue&type=script&lang=js&"
import style0 from "./InvAllList.vue?vue&type=style&index=0&id=5e07564e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e07564e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VChip } from 'vuetify/lib/components/VChip';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VBtn,VChip,VDataTable})
